import { render, staticRenderFns } from "./annularPie.vue?vue&type=template&id=310d8d8c"
import script from "./annularPie.vue?vue&type=script&lang=js"
export * from "./annularPie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('310d8d8c')) {
      api.createRecord('310d8d8c', component.options)
    } else {
      api.reload('310d8d8c', component.options)
    }
    module.hot.accept("./annularPie.vue?vue&type=template&id=310d8d8c", function () {
      api.rerender('310d8d8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/echarts/pie/components/annularPie.vue"
export default component.exports